
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Obecné',
	'widgetId': 'ID modulu widget',
	'widgetType': 'Typ modulu widget',
	'serviceability': 'Servisovatelnost',
	'copyButton': 'Kopírovat',
	'closeButton': 'Zavřít',
	'specification': 'Specifikace',
	'viewSpecification': 'Zobrazit specifikaci'
});
